
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogPostsFR]",
      function () {
        return require("private-next-pages/[...blogPostsFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogPostsFR]"])
      });
    }
  